import { useCallback, useState } from "react";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import { NavLink } from "react-router";
import { getLoggedIn } from "../../../../store/selectors";
import { getLoggedUser } from "../../../../utils";
import { PDLButton, PDLTypography } from "../../dna";
import { Logo } from "../../global";
import PasswordInput from "../_passwordInput";
import "./index.scss";

const LoginForm = ({ onSubmit, loading = false }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const loggedUser = useSelector(getLoggedUser);
  const loggedIn = useSelector(getLoggedIn);

  const isIpAccount = loggedIn && loggedUser && loggedUser.origem === "ip_auth";

  const validate = () => {
    const newErrors = {
      email: "",
      password: "",
    };

    if (!email) {
      newErrors.email = "O e-mail é obrigatório";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Digite um e-mail válido";
    }

    if (!password) {
      newErrors.password = "A senha é obrigatória";
    }

    setErrors(newErrors);

    return !newErrors.email && !newErrors.password;
  };

  const handleLogin = useCallback(async () => {
    if (!validate()) return;

    await onSubmit(email, password);
  }, [email, password, onSubmit]);

  return (
    <div className="pdl_component_loginform">
      <Logo variant="login" className="mb-5" />

      <Form className="d-grid gap-5">
        <div className="d-grid gap-1">
          <PDLTypography display size="md" weight="semibold">
            Acesse sua conta
          </PDLTypography>
          <PDLTypography size="md">
            Olá novamente! Por favor, insira seus dados para continuar.
          </PDLTypography>
        </div>

        <div className="d-grid gap-4">
          <div className="d-grid gap-3">
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                value={email}
                onChange={(evt) => setEmail(evt.target.value)}
                autoComplete="email"
                type="text"
                placeholder="Seu e-mail"
                isInvalid={!!errors.email}
                disabled={loading}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <PasswordInput
              label="Senha"
              value={password}
              onChange={setPassword}
              placeholder="Sua senha"
              isInvalid={!!errors.password}
              error={errors.password}
              disabled={loading}
            />
          </div>

          <div className="d-grid gap-3">
            <PDLButton
              type="button"
              variant="primary"
              onClick={handleLogin}
              size="lg"
            >
              {loading ? <span className="spinner"></span> : "Entrar"}
            </PDLButton>
          </div>

          {isIpAccount && (
            <div className="d-flex align-items-center justify-content-end mt-3">
              <NavLink to="/registrar">Não tem uma conta?</NavLink>
            </div>
          )}
        </div>
      </Form>
    </div>
  );
};

export default LoginForm;
